import { Style } from "./Style";

let defaultStyle;

export class RadioStyle extends Style {
    static get DEFAULT() {
        return defaultStyle || (defaultStyle = new RadioStyle);
    }
    constructor(style = {}, headerStyle = {}, radioThemeStyle = {}) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        super(style, headerStyle), this._size = (null !== (_b = null !== (_a = null == style ? void 0 : style.size) && void 0 !== _a ? _a : null == headerStyle ? void 0 : headerStyle.size) && void 0 !== _b ? _b : null == radioThemeStyle ? void 0 : radioThemeStyle.size) || 14, 
        this._spaceBetweenTextAndIcon = (null !== (_d = null !== (_c = null == style ? void 0 : style.spaceBetweenTextAndIcon) && void 0 !== _c ? _c : null == headerStyle ? void 0 : headerStyle.spaceBetweenTextAndIcon) && void 0 !== _d ? _d : null == radioThemeStyle ? void 0 : radioThemeStyle.spaceBetweenTextAndIcon) || 8, 
        this._spaceBetweenRadio = (null !== (_f = null !== (_e = null == style ? void 0 : style.spaceBetweenRadio) && void 0 !== _e ? _e : null == headerStyle ? void 0 : headerStyle.spaceBetweenRadio) && void 0 !== _f ? _f : null == radioThemeStyle ? void 0 : radioThemeStyle.spaceBetweenRadio) || 2, 
        this._innerRadius = null !== (_h = null === (_g = null == style ? void 0 : style.radioStyle) || void 0 === _g ? void 0 : _g.innerRadius) && void 0 !== _h ? _h : null == radioThemeStyle ? void 0 : radioThemeStyle.innerRadius, 
        this._outerRadius = null !== (_k = null === (_j = null == style ? void 0 : style.radioStyle) || void 0 === _j ? void 0 : _j.outerRadius) && void 0 !== _k ? _k : null == radioThemeStyle ? void 0 : radioThemeStyle.outerRadius, 
        this._defaultFill = null !== (_m = null === (_l = null == style ? void 0 : style.radioStyle) || void 0 === _l ? void 0 : _l.defaultFill) && void 0 !== _m ? _m : null == radioThemeStyle ? void 0 : radioThemeStyle.defaultFill, 
        this._defaultStroke = null !== (_p = null === (_o = null == style ? void 0 : style.radioStyle) || void 0 === _o ? void 0 : _o.defaultStroke) && void 0 !== _p ? _p : null == radioThemeStyle ? void 0 : radioThemeStyle.defaultStroke, 
        this._disableFill = null !== (_r = null === (_q = null == style ? void 0 : style.radioStyle) || void 0 === _q ? void 0 : _q.disableFill) && void 0 !== _r ? _r : null == radioThemeStyle ? void 0 : radioThemeStyle.disableFill, 
        this._checkedFill = null !== (_t = null === (_s = null == style ? void 0 : style.radioStyle) || void 0 === _s ? void 0 : _s.checkedFill) && void 0 !== _t ? _t : null == radioThemeStyle ? void 0 : radioThemeStyle.checkedFill, 
        this._checkedStroke = null !== (_v = null === (_u = null == style ? void 0 : style.radioStyle) || void 0 === _u ? void 0 : _u.checkedStroke) && void 0 !== _v ? _v : null == radioThemeStyle ? void 0 : radioThemeStyle.checkedStroke, 
        this._disableCheckedFill = null !== (_x = null === (_w = null == style ? void 0 : style.radioStyle) || void 0 === _w ? void 0 : _w.disableCheckedFill) && void 0 !== _x ? _x : null == radioThemeStyle ? void 0 : radioThemeStyle.disableCheckedFill, 
        this._disableCheckedStroke = null !== (_z = null === (_y = null == style ? void 0 : style.radioStyle) || void 0 === _y ? void 0 : _y.disableCheckedStroke) && void 0 !== _z ? _z : null == radioThemeStyle ? void 0 : radioThemeStyle.disableCheckedStroke;
    }
    get size() {
        return this._size;
    }
    set size(size) {
        this._size = size;
    }
    get spaceBetweenTextAndIcon() {
        return this._spaceBetweenTextAndIcon;
    }
    set spaceBetweenTextAndIcon(spaceBetweenTextAndIcon) {
        this._spaceBetweenTextAndIcon = spaceBetweenTextAndIcon;
    }
    get spaceBetweenRadio() {
        return this._spaceBetweenRadio;
    }
    set spaceBetweenRadio(spaceBetweenRadio) {
        this._spaceBetweenRadio = spaceBetweenRadio;
    }
    get innerRadius() {
        return this._innerRadius;
    }
    set innerRadius(innerRadius) {
        this._innerRadius = innerRadius;
    }
    get outerRadius() {
        return this._outerRadius;
    }
    set outerRadius(outerRadius) {
        this._outerRadius = outerRadius;
    }
    get defaultFill() {
        return this._defaultFill;
    }
    set defaultFill(defaultFill) {
        this._defaultFill = defaultFill;
    }
    get defaultStroke() {
        return this._defaultStroke;
    }
    set defaultStroke(defaultStroke) {
        this._defaultStroke = defaultStroke;
    }
    get disableFill() {
        return this._disableFill;
    }
    set disableFill(disableFill) {
        this._disableFill = disableFill;
    }
    get checkedFill() {
        return this._checkedFill;
    }
    set checkedFill(checkedFill) {
        this._checkedFill = checkedFill;
    }
    get checkedStroke() {
        return this._checkedStroke;
    }
    set checkedStroke(checkedStroke) {
        this._checkedStroke = checkedStroke;
    }
    get disableCheckedFill() {
        return this._disableCheckedFill;
    }
    set disableCheckedFill(disableCheckedFill) {
        this._disableCheckedFill = disableCheckedFill;
    }
    get disableCheckedStroke() {
        return this._disableCheckedStroke;
    }
    set disableCheckedStroke(disableCheckedStroke) {
        this._disableCheckedStroke = disableCheckedStroke;
    }
    getStyle(style) {
        return new RadioStyle(style, this);
    }
    clone() {
        return new RadioStyle(this);
    }
}
//# sourceMappingURL=RadioStyle.js.map
